import { render, staticRenderFns } from "./grid-mock.vue?vue&type=template&id=fbe7143e&scoped=true&"
import script from "./grid-mock.ts?vue&type=script&lang=ts&"
export * from "./grid-mock.ts?vue&type=script&lang=ts&"
import style0 from "./grid-mock.scss?vue&type=style&index=0&id=fbe7143e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe7143e",
  null
  
)

export default component.exports